export default __webpack_public_path__ + "67a9f049cd79ce6508a7a34af713241d.woff";